export const HEALTH_EVENT_PRIORITY_LIST = [
  { value: 'HIGH', label: 'Alta' },
  { value: 'MEDIUM', label: 'Média' },
  { value: 'LOW', label: 'Baixa' }
]

export const HEALTH_LOGIC_STATUS_MAP = {
  Ativo: 'ACTIVE',
  Renovação: 'RENOVATION',
  'Desistência pelo membro': 'WITHDRAWAL',
  Alta: 'DISCHARGED',
  Cancelado: 'CANCELLED',
  Flexibilização: 'FLEXIBILIZATION'
}

export const HEALTH_LOGIC_STATUS_LIST = Object.keys(
  HEALTH_LOGIC_STATUS_MAP
).map(statusKey => ({
  name: statusKey,
  value: HEALTH_LOGIC_STATUS_MAP[statusKey]
}))

export const HEALTH_EVENT_REFERENCE = {
  APPOINTMENT_SCHEDULE: 'APPOINTMENT_SCHEDULE'
}

export const HEALTH_EVENT_CATEGORY = {
  REFUND_REQUESTED: 'REFUND_REQUESTED'
}
